import React from 'react';

import { AppIcon } from '@backrs_ui/common-ui';

import { Box, SxProps, Theme, Typography } from '@mui/material';

export type GuideMythType = 'myth' | 'mistake';

export type GuideMythItem = Readonly<{
  type: GuideMythType;
  title: string;
  body: string;
}>;

type GuideMythCardProps = Readonly<{
  type: GuideMythType;
  label: string;
  title: string;
  body: string;
}>;

export const GuideMythCard: React.FC<GuideMythCardProps> = ({ type, label, title, body }) => (
  <Box sx={cardSx}>
    <Box sx={type === 'myth' ? mythBadgeSx : mistakeBadgeSx}>
      <AppIcon
        iconName={type === 'myth' ? 'SlashCircle01' : 'AlertTriangle'}
        diameter="14px"
        color={
          type === 'myth' ? 'Colors/Text/text-error-primary' : 'Colors/Text/text-warning-primary'
        }
      />
      <Typography variant="text-xs-semibold">{label}</Typography>
    </Box>
    <Typography variant="text-md-semibold" sx={titleSx}>
      {title}
    </Typography>
    <Typography variant="text-sm-regular" sx={bodySx}>
      {body}
    </Typography>
  </Box>
);

const cardSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-sm'],
  alignItems: 'flex-start',
  p: backrs.spacing['spacing-3xl'],
  border: `1px solid ${backrs.colors['Colors/Border/border-secondary']}`,
  borderRadius: backrs.radius['radius-xl'],
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
});

const titleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});

const mythBadgeSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-xs'],
  py: backrs.spacing['spacing-xxs'],
  px: backrs.spacing['spacing-md'],
  borderRadius: backrs.radius['radius-full'],
  border: '1px solid',
  color: backrs.colors['Colors/Text/text-error-primary'],
  backgroundColor: backrs.colors['Colors/Background/bg-error-primary'],
  borderColor: backrs.colors['Colors/Background/bg-error-secondary'],
});

const mistakeBadgeSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-xs'],
  py: backrs.spacing['spacing-xxs'],
  px: backrs.spacing['spacing-md'],
  borderRadius: backrs.radius['radius-full'],
  border: '1px solid',
  color: backrs.colors['Colors/Text/text-warning-primary'],
  backgroundColor: backrs.colors['Colors/Background/bg-warning-primary'],
  borderColor: backrs.colors['Colors/Background/bg-warning-secondary'],
});
